const translations = {
    'tools.farmers': 'Assigned to farmers',
    'tools.hunters': 'Assigned to hunters',
    'tools.item': '%s • %.1f',
    'tools.noneAssigned': 'No tools assigned.',
    'tools.noneStorage': 'No tools in storage.',
    'tools.unassigned': 'Unassigned tools',
};

export default translations;
